var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',_vm._l((_vm.session.speakers),function(speaker,idx){return _c('speaker-side-bar',{key:idx,attrs:{"speaker":speaker}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }